export const CHANNEL = {
    B2B: 'B2B',
    B2B2C: 'B2B2C',
    D2C: 'D2C',
}